import { useLocation } from 'react-router-dom';
import AdvancedTable from './CustomAntTable';
import { useEffect, useState } from 'react';
import { Tag } from 'antd';

const ParentComponent = () => {
  const location = useLocation();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Dummy data for testing
  const dummyData = [
    {
      id: 1,
      name: 'John Doe',
      email: 'john@example.com',
      status: 'active',
      role: 'admin',
      createdAt: '2024-01-15',
      department: 'Engineering'
    },
    {
      id: 2,
      name: 'Jane Smith',
      email: 'jane@example.com',
      status: 'inactive',
      role: 'user',
      createdAt: '2024-01-10',
      department: 'Marketing'
    },
    {
      id: 3,
      name: 'Mike Johnson',
      email: 'mike@example.com',
      status: 'active',
      role: 'user',
      createdAt: '2024-01-20',
      department: 'Engineering'
    },
    {
      id: 4,
      name: 'Sarah Wilson',
      email: 'sarah@example.com',
      status: 'pending',
      role: 'moderator',
      createdAt: '2024-01-05',
      department: 'Sales'
    },
    {
      id: 5,
      name: 'David Brown',
      email: 'david@example.com',
      status: 'active',
      role: 'user',
      createdAt: '2024-01-25',
      department: 'Support'
    }
  ];

  // Columns configuration
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      render: (status) => {
        const color = status === 'active' ? 'green' : status === 'inactive' ? 'red' : 'orange';
        return <Tag color={color}>{status.toUpperCase()}</Tag>;
      },
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      sorter: true,
    },
    {
      title: 'Department',
      dataIndex: 'department',
      key: 'department',
      sorter: true,
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: true,
    },
  ];

  // Listen to URL changes and fetch data
  useEffect(() => {
    fetchData();
  }, [location.search]); // Trigger when URL search params change

  const fetchData = async () => {
    setLoading(true);
    try {
      // Simulate API call delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // For demo purposes, we'll filter the dummy data based on URL params
      const searchParams = new URLSearchParams(location.search);
      const statusFilter = searchParams.get('status');
      
      let filteredData = [...dummyData];
      
      if (statusFilter) {
        filteredData = dummyData.filter(item => item.status === statusFilter);
      }
      
      // Simulate API response structure
      const response = {
        data: filteredData,
        totalCount: filteredData.length
      };
      
      setTableData(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
      setTableData(dummyData); // Fallback to dummy data
    } finally {
      setLoading(false);
    }
  };

  const filterOptions = [
    {
      field: 'status',
      label: 'Status',
      type: 'single',
      options: [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
        { value: 'pending', label: 'Pending' }
      ]
    },
    {
      field: 'role',
      label: 'Role',
      type: 'multiple',
      options: [
        { value: 'admin', label: 'Admin' },
        { value: 'user', label: 'User' },
        { value: 'moderator', label: 'Moderator' }
      ]
    },
    {
      field: 'department',
      label: 'Department',
      type: 'single',
      options: [
        { value: 'Engineering', label: 'Engineering' },
        { value: 'Marketing', label: 'Marketing' },
        { value: 'Sales', label: 'Sales' },
        { value: 'Support', label: 'Support' }
      ]
    }
  ];

  return (
    <AdvancedTable
      data={tableData}
      columns={columns}
      filterOptions={filterOptions}
      loading={loading}
    />
  );
};

export default ParentComponent;